import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
export const ColorPaperButton = (props) => {
    const { bgColor = 'lightGray', children, className = '', onClick = undefined, } = props;
    return (_jsx(ColorPaper, Object.assign({ bgColor: bgColor, className: clsx('w-full', 'p-4 my-32', 'text-center', className), space: 'none' }, { children: _jsx("button", Object.assign({ className: clsx('block', 'w-full'), onClick: onClick, type: 'button' }, { children: _jsx(LinkText, Object.assign({ size: 'sm' }, { children: children })) })) })));
};
